import script from "./PromptTuningDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptTuningDetail.vue?vue&type=script&setup=true&lang=js"

import "./PromptTuningDetail.vue?vue&type=style&index=0&id=ec256094&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec256094"]])

export default __exports__